import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {
  Label,
  Input,
} from 'reactstrap';

import SettingsItemTitle from './ItemTitle';

import { slugify } from '../../../../helpers';

const SettingsItemSelect = ({
  settingKey,
  setting,
  disabled,
  handleChange,
}) => (
  <>
    <Label for={`setting-${settingKey}`} className={classnames({ disabled })} disabled={disabled}>
      <SettingsItemTitle setting={setting} />
    </Label>
    <div className="input-inner">
      <Input
        type="select"
        className="custom-select"
        name={`setting-${settingKey}`}
        id={`setting-${settingKey}`}
        bsSize="sm"
        value={setting.value}
        disabled={disabled}
        onChange={handleChange}
      >
        {setting.values.map((v, idx) => (
          <option key={slugify(v)} value={v}>
            {setting.labels ? (setting.labels[idx]) : (v)}
          </option>
        ))}
      </Input>
    </div>
  </>
);

SettingsItemSelect.propTypes = {
  settingKey: PropTypes.string.isRequired,
  setting: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
};

SettingsItemSelect.defaultProps = {
  disabled: false,
};

export default SettingsItemSelect;
